import { FAQ } from "./types";

interface CollapsibleItemProps {
	faq: FAQ;
	isOpen: boolean;
	onToggle: () => void;
}

export function CollapsibleItem({ faq, isOpen, onToggle }: CollapsibleItemProps) {
	return (
		<div className="bg-white border border-gray-200 rounded-lg shadow-sm">
			<button onClick={onToggle} className="w-full text-left p-6 hover:bg-gray-50 transition-colors focus-modern">
				<div className="flex justify-between items-center">
					<h3 className="text-lg font-semibold text-gray-800">{faq.question}</h3>
					<span className={`text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`}>
						<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
						</svg>
					</span>
				</div>
			</button>
			<div
				className={`overflow-hidden transition-all duration-300 ease-in-out ${
					isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
				}`}
			>
				<div className="px-6 pb-6">
					<p className="text-gray-600 leading-relaxed">{faq.answer}</p>
				</div>
			</div>
		</div>
	);
}
